import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import urTranslations from './locales/ur.json';
import enTranslations from './locales/en.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            ur: { translation: urTranslations },
            en: { translation: enTranslations }
        },
        lng: 'en', // default language
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;